export default __webpack_public_path__ + "static/media/project-lsl.6633b407.png";